import { useEffect, useState } from 'react';
import useAuth from '../../hooks/useAuth';
import { Quiz, QuizRawData } from '../../models/Quiz';
import api from '../../services/api';

export const useQuizPage = () => {
  const { user: student } = useAuth();
  const [studentQuizzes, setStudentQuizzes] = useState<Quiz[]>([]);

  useEffect(() => {
    const fetchQuizzes = async () => {
      const { data } = await api.get<QuizRawData[]>(
        `/quiz/by-student/${student.id}`,
      );
      const quizzes: Quiz[] = data.map(quizData => {
        // Verifique se grades não está vazio antes de chamar o reduce
        const attempt =
          quizData.grades && quizData.grades.length > 0
            ? quizData.grades.reduce((a, b) => (a.note > b.note ? a : b))
            : null;

        // Se não houver nenhum attempt, você pode definir valores padrão
        if (!attempt) {
          return {
            id: quizData.id,
            title: quizData.title,
            tags: quizData.tags,
            description: quizData.description,
            questions: quizData.questions,
            isCompleted: false, // ou outro valor padrão
            attempts: 0, // ou outro valor padrão
            answers: {}, // ou outro valor padrão
            note: 0, // ou outro valor padrão
          } as Quiz;
        }

        return {
          id: quizData.id,
          title: quizData.title,
          tags: quizData.tags,
          description: quizData.description,
          questions: quizData.questions,
          isCompleted: attempt.isCompleted,
          attempts: attempt.attempts,
          answers: attempt.answers,
          note: attempt.note,
          doneAt: attempt.doneAt ? new Date(attempt.doneAt) : new Date(),
        } as Quiz;
      });
      setStudentQuizzes(quizzes);
    };
    fetchQuizzes();
  }, [student.id]);

  const getQuizById = (quizId: string) => {
    return studentQuizzes.find(quiz => quiz.id === quizId);
  };

  return {
    studentQuizzes,
    getQuizById,
  };
};
